import { selectedIsAuthorized } from '@shared-core/features/auth'
import { useAppSelector } from '@shared-core/store'
import { homePath, loginPath } from '@web/router/routes-screens'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

// Приватная зона: гость уходит на логин, возврат сохраняется в state.
export function PrivateGuard() {
  const isAuthorized = useAppSelector(selectedIsAuthorized)
  const location = useLocation()

  if (!isAuthorized) {
    return <Navigate to={loginPath} replace state={{ from: location }} />
  }

  return <Outlet />
}

// Гостевая зона: авторизованного сразу на home.
export function PublicGuard() {
  const isAuthorized = useAppSelector(selectedIsAuthorized)

  const location = useLocation()

  if (isAuthorized && location.pathname !== homePath) {
    return <Navigate to={homePath} replace />
  }

  return <Outlet />
}
